import './Default.scss';

ComponentManager.init(document.body);
